import type { SupabaseClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

export const supabaseReady = Boolean(url && key)

let pending: Promise<SupabaseClient> | null = null

/**
 * Loaded on demand, never in the first bundle.
 *
 * The client is only needed twice: when someone presses the sign-in button,
 * and when the browser comes back from Google. A staff member who is already
 * signed in never downloads it at all -- which on a slow Jodhpur line is the
 * difference between the portal opening and the portal appearing to hang.
 */
export function getSupabase(): Promise<SupabaseClient> {
  pending ??= import('@supabase/supabase-js').then(({ createClient }) =>
    createClient(url, key, {
      auth: {
        // PKCE stores a code verifier between leaving for Google and
        // returning, so storage has to survive the redirect. We sign out
        // locally the moment the token is exchanged, so nothing lingers.
        persistSession: true,
        autoRefreshToken: false,  // our cookie is the session, not this token
        detectSessionInUrl: true, // reads the OAuth redirect
        flowType: 'pkce',
      },
    }))
  return pending
}

/** True when this page load is a return trip from the Google redirect. */
export function isOAuthReturn(): boolean {
  return window.location.hash.includes('access_token') ||
         new URLSearchParams(window.location.search).has('code')
}
